$(document).on('turbolinks:load', () => {
  let $toggleNews = $('.toggle-news-bookmarks')

  $toggleNews.on('click', () => {
    $('.right-block').toggle()
    $('.toggle-news-bookmarks-container').toggleClass('closed')
  })
})
